// We import the log sinks as early as possible, so that our logging pipeline is established as early as possible
import "~/utils/logging/configureGlobalLoggerForPortal";
import "~/openTelemetry/tracing";
import "./polyfills";
import type { BrowserClient } from "@amplitude/analytics-types";
import { logger } from "@octopusdeploy/logging";
import { Environment } from "@octopusdeploy/utilities";
import * as ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import "./global.less";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/regular.min.css";
import "@fortawesome/fontawesome-free/css/solid.min.css";
import type { AuthExtension } from "~/authExtensionsManager";
import { authExtensionManager } from "~/authExtensionsManager";
import "~/components/Actions";
import "~/components/Features";
import "~/areas/startup";
import type { ChameleonContext } from "~/inAppMessaging/InAppMessaging";
import App from "./App";
declare global {
    interface Window {
        Octopus: {
            registerExtension: (name: string, type: string, extension: AuthExtension) => void;
        };
        showSnackbar: boolean;
        snackbarText: string;
        chmln?: {
            clear: () => void;
            show?: (experienceNameOrId: string) => void;
            data?: {
                profile: {
                    attributes: {
                        [key: string]: string;
                    };
                };
                campaigns?: ChameleonCampaign[];
            };
            on: (event: "after:account" | "after:profile", callback: () => void) => void;
        };
        chmlnContext: ChameleonContext;
        amplitude?: BrowserClient;
    }
}
interface ChameleonCampaign {
    get(key: "name" | "id"): string;
    isAvailable(): boolean;
}
window.Octopus = {
    registerExtension: (name, type, extension) => {
        if (type !== "auth_provider") {
            throw new Error("Only auth provider extensions are currently supported");
        }
        authExtensionManager.registerAuthExtension(name, extension);
    },
};
function render(Component: typeof App) {
    const container = document.getElementById("app");
    const isReact18RenderingEnabled = Environment.isInDevelopmentMode() || document.querySelector("meta[name='react-18-rendering-feature-toggle']")?.getAttribute("content") === "true";
    if (isReact18RenderingEnabled) {
        logger.info("Rendering using createRoot API");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const root = createRoot(container!);
        root.render(<Component />);
    }
    else {
        logger.info("Rendering using legacy root API");
        ReactDOM.render(<Component />, container);
    }
}
render(App);
